import { toast, ToastOptions } from "react-toastify";

type ToastMessage = string;

const OPTIONS: ToastOptions = {
  position: "top-right",
  autoClose: 1000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

export const SuccessToast = (message: ToastMessage) => {
  toast.success(message, OPTIONS);
};

export const ErrorToast = (message: ToastMessage) => {
  toast.error(message, OPTIONS);
};
